<template>
  <div class="notification-container" :class="{ 'active': showResponseMsg }">
    <div class="notification-msg">
      <p :class="{'success':isSuccess, 'failed':!isSuccess}" >{{ notificationMsg }}</p>
    </div>
  </div>
</template>
<script>
  export default {
    data() {
      return {
        showResponseMsg: false,
        notificationMsg: '',
        isSuccess: false
      };
    },
    methods: {
      showNotification(show,msg,status) {
        this.showResponseMsg = show;
        this.notificationMsg = msg;
        this.isSuccess = status;
        setTimeout(()=>{
          this.showResponseMsg = false;
        },3000);
      }
    }
  };
</script>
<style lang="scss" src="./bo-notification.scss"></style>
